export const introToTech = {
  title: {
    en: 'Intro to technology',
    es: 'Intro a la tecnología',
  },
  subtitle: {
    en: 'A course for people who want to learn more about the tools they use everyday.',
    es: 'Un curso para personas que quieren aprender más sobre las herramientas que usan todos los días.',
  },
  sessions: [
    {
      title: {
        en: 'Beginnings',
        es: 'Principios',
      },
      chapters: [
        {
          title: {
            en: 'Why is it important?',
            es: '¿Por qué es importante?',
          },
          sections: [
            {
              title: {
                en: 'You already know why',
                es: 'Ya sabes',
              }
            },
            {
              title: {
                en: 'Technology in everything',
                es: 'La tecnología en todo',
              }
            },
            {
              title: {
                en: 'The future',
                es: 'El futuro',
              }
            },
          ]
        },
        {
          title: {
            en: 'What are our goals?',
            es: '¿Cuáles son nuestras metas?',
          },
          sections: [
            {
              title: {
                en: "Survey needs of members",
                es: 'Averiguar las necesidades de los miembros'
              },
            },
            {
              title: {
                en: "Tech proficiency",
                es: 'Competencia en tech',
              }
            },
            {
              title: {
                en: "Professional development",
                es: "Desarrollo profesional",
              }
            },
            {
              title: {
                en: "Community empowerment",
                es: "Empoderamiento comunitario",
              }
            },
            {
              title: {
                en: "Have fun and do interesting things",
                es: "Divertirte y hacer cosas interesantes",
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Computers',
        es: 'Computadoras',
      },
      chapters: [
        {
          title: {
            en: 'Basic operation',
            es: 'Operación básica',
          },
          sections: [
            {
              title: {
                en: 'On/off',
                es: 'Prendida/apagada',
              }
            },
            {
              title: {
                en: 'Sign in/out',
                es: 'Registrarse/salir',
              }
            },
            {
              title: {
                en: 'Opening, closing apps',
                es: 'Abrir, cerrar apps',
              }
            },
            {
              title: {
                en: 'Navigating the OS',
                es: 'Navegar el OS',
              }
            },
          ]
        },
        {
          title: {
            en: 'Using a browser',
            es: 'Usar un navegador',
          },
          sections: [
            {
              title: {
                en: 'Google, DuckDuckGo, other search engines',
                es: 'Google, DuckDuckGo, otros buscadores',
              }
            },
            {
              title: {
                en: 'Finding anything you are looking for',
                es: 'Encontrar cualquier cosa que buscas',
              }
            },
            {
              title: {
                en: 'Using keywords and filters',
                es: 'Usar palabras claves y filtros',
              }
            },
            {
              title: {
                en: 'Common use cases',
                es: 'Casos de uso communes',
              }
            },
            {
              title: {
                en: 'Learning how to do something',
                es: 'Aprender como hacer algo',
              }
            },
          ]
        },
        {
          title: {
            en: 'Commonly used apps',
            es: 'Apps usadas frecuentemente',
          },
          sections: [
            {
              title: {
                en: 'Text editors (Word, Google Docs, VSCode, etc.)',
                es: 'Editores de texto (Word, Google Docs, VSCode, etc.)',
              }
            },
            {
              title: {
                en: 'Spreadsheets (Excel, Google Sheets, etc.)',
                es: 'Hojas de cálculo (Excel, Google Sheets, etc.)',
              }
            },
            {
              title: {
                en: 'More (calendar, calculator, minesweeper, etc.)',
                es: 'Más (calendario, calculadora, minesweeper, etc.)',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Phones',
        es: 'Teléfonos',
      },
      chapters: [
        {
          title: {
            en: 'Basic operation',
            es: 'Operación básica',
          },
          sections: [
            {
              title: {
                en: 'On/off',
                es: 'Prendida/apagada',
              }
            },
            {
              title: {
                en: 'Setting everything up',
                es: 'Preparar todo',
              }
            },
            {
              title: {
                en: 'Security and protecting your data',
                es: 'La seguridad y protejer tus datos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Calls',
            es: 'Llamadas',
          },
          sections: [
            {
              title: {
                en: 'Making and receiving calls',
                es: 'Hacer y recibir llamadas',
              },
            },
            {
              title: {
                en: 'Voicemail',
                es: 'Mensaje de voz',
              }
            },
            {
              title: {
                en: 'Using contacts',
                es: 'Usar contactos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Messages',
            es: 'Mensajes',
          },
          sections: [
            {
              title: {
                en: 'Text messages',
                es: 'Mensajes de texto',
              }
            },
            {
              title: {
                en: 'Whatsapp',
                es: 'Whatsapp',
              }
            },
            {
              title: {
                en: 'Facebook Messenger',
                es: 'Facebook Messenger',
              }
            },
            {
              title: {
                en: 'Hangouts',
                es: 'Hangouts',
              }
            },
            {
              title: {
                en: 'Signal',
                es: 'Signal',
              }
            },
            {
              title: {
                en: 'More',
                es: 'Más',
              }
            },
          ]
        },
        {
          title: {
            en: 'Maps and GPS',
            es: 'Mapas y GPS',
          },
          sections: [
            {
              title: {
                en: 'Google Maps',
                es: 'Google Maps',
              }
            },
            {
              title: {
                en: 'Waze',
                es: 'Waze',
              }
            },
            {
              title: {
                en: 'Apple Maps',
                es: 'Apple Maps',
              }
            },
          ]
        },
        {
          title: {
            en: 'Other apps',
            es: 'Otras apps',
          },
          sections: [
            {
              title: {
                en: 'Camera',
                es: 'Cámara',
              }
            },
            {
              title: {
                en: 'Clock',
                es: 'Reloj',
              }
            },
            {
              title: {
                en: 'Contacts',
                es: 'Contactos',
              }
            },
            {
              title: {
                en: 'Photos',
                es: 'Fotos',
              }
            },
            {
              title: {
                en: 'Calendar',
                es: 'Calendario',
              }
            },
            {
              title: {
                en: 'Calculator',
                es: 'Calculadora',
              }
            },
            {
              title: {
                en: 'Voice recording',
                es: 'Grabadora de voz',
              }
            },
            {
              title: {
                en: 'Notes',
                es: 'Apuntes',
              }
            },
            {
              title: {
                en: 'More',
                es: 'Más',
              }
            },
          ]
        },
        {
          title: {
            en: 'Getting apps',
            es: 'Conseguir apps',
          },
          sections: [
            {
              title: {
                en: 'Google Play Store',
                es: 'Google Play Store',
              }
            },
            {
              title: {
                en: 'Apple App Store',
                es: 'Apple App Store',
              }
            },
            {
              title: {
                en: 'Downloading and installing',
                es: 'Descargar y instalar',
              }
            },
            {
              title: {
                en: 'Permissions and configuration',
                es: 'Permisos y configuración',
              }
            },
          ]
        },
        {
          title: {
            en: 'How cell networks work',
            es: 'Cómo funcionan las redes celulares',
          },
          sections: [
            {
              title: {
                en: 'Networks and topography',
                es: 'Redes y topografía',
              }
            },
            {
              title: {
                en: 'Data on your phone and network',
                es: 'Datos en tu teléfono y red',
              }
            },
            {
              title: {
                en: 'Security concerns (location tracking, call monitoring, etc.)',
                es: 'Seguridad (el monitoreo de ubicación y llamadas, etc.)',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Security',
        es: 'La seguridad',
      },
      chapters: [
        {
          title: {
            en: 'What is hacking?',
            es: '¿Qué es el hacking?',
          },
          sections: [
            {
              title: {
                en: 'Well known data breaches',
                es: 'Robos de datos famosos',
              }
            },
            {
              title: {
                en: 'How does it work?',
                es: '¿Cómo funciona?',
              }
            },
            {
              title: {
                en: 'Blackhat, whitehat, grayhat',
                es: 'Blackhat, whitehat, grayhat',
              }
            },
          ]
        },
        {
          title: {
            en: 'Protect yourself',
            es: 'Protejerte',
          },
          sections: [
            {
              title: {
                en: 'Low-hanging fruit',
                es: 'Fruta madura',
              }
            },
            {
              title: {
                en: 'Passwords',
                es: 'Contraseñas',
              }
            },
            {
              title: {
                en: 'HTTPS, TLS, and encryption',
                es: 'HTTPS, TLS, y la codificación',
              }
            },
          ]
        },
      ]      
    },
  ]
}





export const webDev = {
  title: {
    en: 'Software development',
    es: 'Desarrollo de software',
  },
  subtitle: {
    en: 'A course for people who want to learn how to create apps using code.',
    es: 'Un curso para personas que quieren aprender a crear aplicaciones usando el código.',
  },
  sessions: [
    {
      title: {
        en: 'Beginnings',
        es: 'Principios',
      },
      chapters: [
        {
          title: {
            en: "It's all about data",
            es: "Todo es dato",
          },
          sections: [
            {
              title: {
                en: 'Binary',
                es: 'Binario',
              }
            },
            {
              title: {
                en: 'Data transfer',
                es: 'Transferencia de dato',
              }
            },
            {
              title: {
                en: 'The internet',
                es: 'El internet',
              }
            },
          ]
        },
        {
          title: {
            en: 'The browser',
            es: 'El navegador',
          },
          sections: [
            {
              title: {
                en: "Core functionality",
                es: "Funcionalidad central",
              }
            },
            {
              title: {
                en: "What is a browser actually doing?",
                es: "¿Qué está haciendo un navegador realmente?",
              }
            },
            {
              title: {
                en: "Intro to dev tools",
                es: "Intro a dev tools",
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Tools',
        es: 'Herramientas',
      },
      chapters: [
        {
          title: {
            en: 'Programs',
            es: 'Programas',
          },
          sections: [
            {
              title: {
                en: 'Text editors',
                es: 'Editores de texto',
              }
            },
            {
              title: {
                en: 'Command line',
                es: 'Command line',
              }
            },
            {
              title: {
                en: 'Browser dev tools',
                es: 'Dev tools del navegador',
              }
            },
            {
              title: {
                en: 'Working with files',
                es: 'Trabajar con archivos',
              }
            },
            {
              title: {
                en: 'More tools',
                es: 'Más herramientas',
              }
            },
          ]
        },
        {
          title: {
            en: 'Languages of the browser',
            es: 'Idiomas del navegador',
          },
          sections: [
            {
              title: {
                en: 'HTML',
                es: 'HTML',
              }
            },
            {
              title: {
                en: 'CSS',
                es: 'CSS',
              }
            },
            {
              title: {
                en: 'Javascript',
                es: 'Javascript',
              }
            },
            {
              title: {
                en: 'How they work together',
                es: 'Cómo funcionan juntos',
              }
            },
            {
              title: {
                en: 'Frameworks',
                es: 'Frameworks',
              }
            },
          ]
        },
        {
          title: {
            en: 'Following the rules',
            es: 'Seguir las reglas',
          },
          sections: [
            {
              title: {
                en: 'Protocols',
                es: 'Protocolos',
              }
            },
            {
              title: {
                en: 'APIs',
                es: 'APIs',
              }
            },
            {
              title: {
                en: 'Documentation',
                es: 'Documentación',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Build a website',
        es: 'Crear un sitio web',
      },
      chapters: [
        {
          title: {
            en: 'HTML file',
            es: 'Archivo de HTML',
          },
          sections: [
            {
              title: {
                en: 'Tags',
                es: 'Etiquetas',
              }
            },
            {
              title: {
                en: 'Showing text',
                es: 'Mostrar texto',
              }
            },
            {
              title: {
                en: 'Creating a link',
                es: 'Crear un enlace',
              }
            },
            {
              title: {
                en: 'Showing an image',
                es: 'Mostrar una imagen',
              }
            },
            {
              title: {
                en: 'Making a button',
                es: 'Crear un botón',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
            {
              title: {
                en: 'Best practices',
                es: 'Mejores prácticas',
              }
            },
          ]
        },
        {
          title: {
            en: 'CSS file',
            es: 'Archivo de CSS',
          },
          sections: [
            {
              title: {
                en: 'Selectors',
                es: 'Selectores',
              }
            },
            {
              title: {
                en: 'Style properties',
                es: 'Propiedades de estilo',
              }
            },
            {
              title: {
                en: 'Linking with HTML',
                es: 'Conectar con HTML',
              }
            },
          ]
        },
        {
          title: {
            en: 'Javascript file',
            es: 'Archivo de Javascript',
          },
          sections: [
            {
              title: {
                en: 'Super fundamentals of programming',
                es: 'Los fundamentales de la programación',
              }
            },
            {
              title: {
                en: 'Add click listener',
                es: 'Añadir oyente de click',
              }
            },
            {
              title: {
                en: 'Console logging',
                es: 'Registro de la consola',
              }
            },
            {
              title: {
                en: 'Where to go from here',
                es: 'Adónde ir de aquí',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Developing our websites',
        es: 'Desarrollar nuestros sitios',
      },
      chapters: [
        {
          title: {
            en: 'Going deeper into Javascript',
            es: 'Ir más profundamente en el Javascript',
          },
          sections: [
            {
              title: {
                en: 'Programming languages',
                es: 'Idiomas de la programación',
              }
            },
            {
              title: {
                en: 'Javascript is not Java',
                es: 'Javascript no es Java',
              }
            },
            {
              title: {
                en: 'Core concepts',
                es: 'Conceptos centrales',
              }
            },
            {
              title: {
                en: 'Variables',
                es: 'Variables',
              }
            },
            {
              title: {
                en: 'Primitives',
                es: 'Primitivos',
              }
            },
            {
              title: {
                en: 'Functions',
                es: 'Funciones',
              }
            },
            {
              title: {
                en: 'Environment',
                es: 'Entorno',
              }
            },
            {
              title: {
                en: 'Iteration',
                es: 'Iteración',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Counter app',
            es: 'App de contar',
          },
          sections: [
            {
              title: {
                en: 'Create image with caption',
                es: 'Crear una imagen con subtítulo',
              }
            },
            {
              title: {
                en: 'Add event listener and count clicks',
                es: 'Añadir oyente de click y contar clicks',
              }
            },
            {
              title: {
                en: 'Takeaways',
                es: 'Conclusiones',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Web app architecture',
        es: 'Arquitectura de los web apps',
      },
      chapters: [
        {
          title: {
            en: 'APIs and backends',
            es: 'APIs y backends',
          },
          sections: [
            {
              title: {
                en: 'Server / client',
                es: 'Servidor / cliente',
              }
            },
            {
              title: {
                en: 'Request / response',
                es: 'Solicitud / respuesta',
              }
            },
            {
              title: {
                en: 'IP addresses, DNS, etc.',
                es: 'Direcciones de IP, DNS, etc.',
              }
            },
          ]
        },
        {
          title: {
            en: 'Communication between server and client',
            es: 'Comunicación entre servidor y cliente',
          },
          sections: [
            {
              title: {
                en: 'HTTP protocol',
                es: 'Protocolo de HTTP',
              }
            },
            {
              title: {
                en: 'Network layer models',
                es: 'Modelos de las capas de red',
              }
            },
            {
              title: {
                en: 'Request properties',
                es: 'Propiedades de solicitud',
              }
            },
            {
              title: {
                en: 'Response properties',
                es: 'Propiedades de respuesta',
              }
            },
            {
              title: {
                en: 'Live example on local network',
                es: 'Ejemplo en vivo en la red local',
              }
            },
            {
              title: {
                en: 'Just files on a network',
                es: 'Solamente archivos en una red',
              }
            },
          ]
        },
        {
          title: {
            en: 'Backend architecture',
            es: 'Arquitectura del backend',
          },
          sections: [
            {
              title: {
                en: 'Servers',
                es: 'Servidores',
              }
            },
            {
              title: {
                en: 'Frameworks',
                es: 'Frameworks',
              }
            },
            {
              title: {
                en: 'Databases, SQL, NoSQL, persisting data',
                es: 'Bases de datos, SQL, NoSQL, guardar datos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Version control and teamwork',
            es: 'Control de versión y trabajo en equipo',
          },
          sections: [
            {
              title: {
                en: 'Why is it important?',
                es: '¿Por qué es importante?',
              }
            },
            {
              title: {
                en: 'Git',
                es: 'Git',
              }
            },
            {
              title: {
                en: 'Github',
                es: 'Github',
              }
            },
            {
              title: {
                en: 'Common use cases',
                es: 'Casos de uso comunes',
              }
            },
            {
              title: {
                en: 'Team collaboration best practices',
                es: 'Mejores prácticas en un equipo',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Beyond web apps',
        es: 'Más allá los web apps',
      },
      chapters: [
        {
          title: {
            en: 'Other types of apps',
            es: 'Otros tipos de apps',
          },
          sections: [
            {
              title: {
                en: 'Desktop apps',
                es: 'Apps de desktop',
              }
            },
            {
              title: {
                en: 'Mobile apps',
                es: 'Apps móviles',
              }
            },
            {
              title: {
                en: 'Java, Swift, other common languages',
                es: 'Java, Swift, otros idiomas comunes',
              }
            },
          ]
        },
        {
          title: {
            en: 'Advanced programming',
            es: 'Programación avanzada',
          },
          sections: [
            {
              title: {
                en: 'Data structures',
                es: 'Estructuras de dato',
              }
            },
            {
              title: {
                en: 'Algorithms',
                es: 'Algoritmos',
              }
            },
            {
              title: {
                en: 'Recursion',
                es: 'Recursión',
              }
            },
            {
              title: {
                en: 'Problem solving techniques',
                es: 'Técnicas para solucionar problemas',
              }
            },
            {
              title: {
                en: 'Machine learning',
                es: 'Aprendizaje automático',
              }
            },
            {
              title: {
                en: 'Artificial intelligence',
                es: 'Inteligencia artificial',
              }
            },
          ]
        },
        {
          title: {
            en: 'Hardware',
            es: 'Hardware',
          },
          sections: [
            {
              title: {
                en: 'Endless possibilities',
                es: 'Posibilidades infinitas',
              }
            },
            {
              title: {
                en: 'Arduino and Raspberry PI',
                es: 'Arduino y Raspberry PI',
              }
            },
            {
              title: {
                en: 'Home automation',
                es: 'Automatización de la casa',
              }
            },
            {
              title: {
                en: 'Going forward',
                es: 'Avanzar',
              }
            },
          ]
        },
      ]      
    },
  ]
}


export const language = {
  title: {
    en: 'English language',
    es: 'Inglés',
  },
  subtitle: {
    en: 'A course for people who want to improve their English skills.',
    es: 'Un curso para personas que quieren mejoror sus habilidades de inglés.',
  },
  sessions: [
    {
      title: {
        en: 'Beginnings',
        es: 'Principios',
      },
      chapters: [
        {
          title: {
            en: 'Why is it important?',
            es: '¿Por qué es importante?',
          },
          sections: [
            {
              title: {
                en: 'You already know why',
                es: 'Ya sabes',
              }
            },
            {
              title: {
                en: 'Language in everything',
                es: 'Idioma en todo',
              }
            },
            {
              title: {
                en: 'Learning techniques',
                es: 'Técnicas de aprendizaje',
              }
            },
          ]
        },
        {
          title: {
            en: 'What are our goals?',
            es: '¿Cuáles son nuestras metas?',
          },
          sections: [
            {
              title: {
                en: "Survey needs of members",
                es: "Averiguar las necesidades de los miembros",
              }
            },
            {
              title: {
                en: "Professional development",
                es: "Desarrollo profesional",
              }
            },
            {
              title: {
                en: "Language as a tool of empowerment",
                es: "El idioma como una herramienta de empoderamiento",
              }
            },
            {
              title: {
                en: "Language and culture",
                es: "El idioma y la cultura",
              }
            },
            {
              title: {
                en: "Have fun and do interesting things",
                es: "Divertirte y hacer cosas interesantes",
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Parts of speech',
        es: 'Las partes de la oración',
      },
      chapters: [
        {
          title: {
            en: 'Nouns',
            es: 'Sustantivos',
          },
          sections: [
            {
              title: {
                en: 'Persons',
                es: 'Personas',
              }
            },
            {
              title: {
                en: 'Places',
                es: 'Lugares',
              }
            },
            {
              title: {
                en: 'Things',
                es: 'Cosas',
              }
            },
            {
              title: {
                en: 'Singular and plural',
                es: 'Singular y plural',
              }
            },
            {
              title: {
                en: 'Articles and demonstratives',
                es: 'Artículos y demonstrativos',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Modifiers',
            es: 'Modificadores',
          },
          sections: [
            {
              title: {
                en: 'Adjectives',
                es: 'Adjetivos',
              }
            },
            {
              title: {
                en: 'Adverbs',
                es: 'Adverbios',
              }
            },
            {
              title: {
                en: 'Placement',
                es: 'Colocación',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Verbs',
            es: 'Verbos',
          },
          sections: [
            {
              title: {
                en: 'Taking action',
                es: 'Acciones',
              }
            },
            {
              title: {
                en: 'Tense',
                es: 'Tiempo',
              }
            },
            {
              title: {
                en: 'Person',
                es: 'Persona',
              }
            },
            {
              title: {
                en: 'Patterns, rules, and exceptions',
                es: 'Patrones, reglas, y excepciones',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Grammar',
        es: 'La gramática',
      },
      chapters: [
        {
          title: {
            en: 'Syntax',
            es: 'La sintaxis',
          },
          sections: [
            {
              title: {
                en: 'Basic sentences',
                es: 'Oraciones básicas',
              }
            },
            {
              title: {
                en: 'Building up to more complex sentences',
                es: 'Construir oraciones más complejas',
              }
            },
            {
              title: {
                en: 'Common use cases',
                es: 'Casos de uso comunes',
              }
            },
          ]
        },
        {
          title: {
            en: 'Punctuation',
            es: 'Puntuación',
          },
          sections: [
            {
              title: {
                en: 'Periods',
                es: 'Puntos',
              }
            },
            {
              title: {
                en: 'Commas',
                es: 'Comas',
              }
            },
            {
              title: {
                en: 'Other marks',
                es: 'Otros',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Text to speech to thought',
        es: 'Texto a habla a pensamiento',
      },
      chapters: [
        {
          title: {
            en: 'Thinking in words',
            es: 'Pensar en palabras',
          },
          sections: [
            {
              title: {
                en: 'Methods for thinking in English',
                es: 'Métodos para pensar en inglés',
              }
            },
            {
              title: {
                en: 'Practice techniques',
                es: 'Técnicas de práctica',
              }
            },
            {
              title: {
                en: 'Immersion',
                es: 'Immersión',
              }
            },
          ]
        },
        {
          title: {
            en: 'Reading and writing',
            es: 'Leer y escribir',
          },
          sections: [
            {
              title: {
                en: 'Reading comprehension',
                es: 'Comprensión lectora',
              }
            },
            {
              title: {
                en: 'Challenges of writing',
                es: 'Desafíos de escribir',
              }
            },
            {
              title: {
                en: 'Writing like you speak',
                es: 'Escribir como hablas',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'The next level',
        es: 'El siguiente nivel',
      },
      chapters: [
        {
          title: {
            en: 'Conversation',
            es: 'Conversación',
          },
          sections: [
            {
              title: {
                en: 'Sound like a native speaker',
                es: 'Sonar como un hablante nativo',
              }
            },
            {
              title: {
                en: 'Practice with native speakers',
                es: 'Practicar con hablantes nativos',
              }
            },
            {
              title: {
                en: 'Taking feedback and growing',
                es: 'Aceptar críticas y crecer',
              }
            },
          ]
        },
        {
          title: {
            en: 'Pronunciation',
            es: 'Pronunciación',
          },
          sections: [
            {
              title: {
                en: 'English is hard',
                es: 'Inglés es difícil',
              }
            },
            {
              title: {
                en: 'Methods for improvement',
                es: 'Métodos para mejorar',
              }
            },
            {
              title: {
                en: 'The vowels',
                es: 'Los vocales',
              }
            },
            {
              title: {
                en: 'The consonants',
                es: 'Las consonantes',
              }
            },
          ]
        },
      ]      
    },
  ]
}

export const spanishLanguage = {
  title: {
    en: 'Spanish language',
    es: 'Español',
  },
  subtitle: {
    en: 'A course for people who want to improve their Spanish skills.',
    es: 'Un curso para personas que quieren mejoror sus habilidades de español.',
  },
  sessions: [
    {
      title: {
        en: 'Beginnings',
        es: 'Principios',
      },
      chapters: [
        {
          title: {
            en: 'Why is it important?',
            es: '¿Por qué es importante?',
          },
          sections: [
            {
              title: {
                en: 'You already know why',
                es: 'Ya sabes',
              }
            },
            {
              title: {
                en: 'Language in everything',
                es: 'Idioma en todo',
              }
            },
            {
              title: {
                en: 'Learning techniques',
                es: 'Técnicas de aprendizaje',
              }
            },
          ]
        },
        {
          title: {
            en: 'What are our goals?',
            es: '¿Cuáles son nuestras metas?',
          },
          sections: [
            {
              title: {
                en: "Survey needs of members",
                es: "Averiguar las necesidades de los miembros",
              }
            },
            {
              title: {
                en: "Professional development",
                es: "Desarrollo profesional",
              }
            },
            {
              title: {
                en: "Language as a tool of empowerment",
                es: "El idioma como una herramienta de empoderamiento",
              }
            },
            {
              title: {
                en: "Language and culture",
                es: "El idioma y la cultura",
              }
            },
            {
              title: {
                en: "Have fun and do interesting things",
                es: "Divertirte y hacer cosas interesantes",
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Parts of speech',
        es: 'Las partes de la oración',
      },
      chapters: [
        {
          title: {
            en: 'Nouns',
            es: 'Sustantivos',
          },
          sections: [
            {
              title: {
                en: 'Persons',
                es: 'Personas',
              }
            },
            {
              title: {
                en: 'Places',
                es: 'Lugares',
              }
            },
            {
              title: {
                en: 'Things',
                es: 'Cosas',
              }
            },
            {
              title: {
                en: 'Singular and plural',
                es: 'Singular y plural',
              }
            },
            {
              title: {
                en: 'Articles and demonstratives',
                es: 'Artículos y demonstrativos',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Modifiers',
            es: 'Modificadores',
          },
          sections: [
            {
              title: {
                en: 'Adjectives',
                es: 'Adjetivos',
              }
            },
            {
              title: {
                en: 'Adverbs',
                es: 'Adverbios',
              }
            },
            {
              title: {
                en: 'Placement',
                es: 'Colocación',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
        {
          title: {
            en: 'Verbs',
            es: 'Verbos',
          },
          sections: [
            {
              title: {
                en: 'Taking action',
                es: 'Acciones',
              }
            },
            {
              title: {
                en: 'Tense',
                es: 'Tiempo',
              }
            },
            {
              title: {
                en: 'Person',
                es: 'Persona',
              }
            },
            {
              title: {
                en: 'Patterns, rules, and exceptions',
                es: 'Patrones, reglas, y excepciones',
              }
            },
            {
              title: {
                en: 'Examples',
                es: 'Ejemplos',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Grammar',
        es: 'La gramática',
      },
      chapters: [
        {
          title: {
            en: 'Syntax',
            es: 'La sintaxis',
          },
          sections: [
            {
              title: {
                en: 'Basic sentences',
                es: 'Oraciones básicas',
              }
            },
            {
              title: {
                en: 'Building up to more complex sentences',
                es: 'Construir oraciones más complejas',
              }
            },
            {
              title: {
                en: 'Common use cases',
                es: 'Casos de uso comunes',
              }
            },
          ]
        },
        {
          title: {
            en: 'Punctuation',
            es: 'Puntuación',
          },
          sections: [
            {
              title: {
                en: 'Periods',
                es: 'Puntos',
              }
            },
            {
              title: {
                en: 'Commas',
                es: 'Comas',
              }
            },
            {
              title: {
                en: 'Other marks',
                es: 'Otros',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'Text to speech to thought',
        es: 'Texto a habla a pensamiento',
      },
      chapters: [
        {
          title: {
            en: 'Thinking in words',
            es: 'Pensar en palabras',
          },
          sections: [
            {
              title: {
                en: 'Methods for thinking in Spanish',
                es: 'Métodos para pensar en español',
              }
            },
            {
              title: {
                en: 'Practice techniques',
                es: 'Técnicas de práctica',
              }
            },
            {
              title: {
                en: 'Immersion',
                es: 'Immersión',
              }
            },
          ]
        },
        {
          title: {
            en: 'Reading and writing',
            es: 'Leer y escribir',
          },
          sections: [
            {
              title: {
                en: 'Reading comprehension',
                es: 'Comprensión lectora',
              }
            },
            {
              title: {
                en: 'Challenges of writing',
                es: 'Desafíos de escribir',
              }
            },
            {
              title: {
                en: 'Writing like you speak',
                es: 'Escribir como hablas',
              }
            },
          ]
        },
      ]      
    },

    {
      title: {
        en: 'The next level',
        es: 'El siguiente nivel',
      },
      chapters: [
        {
          title: {
            en: 'Conversation',
            es: 'Conversación',
          },
          sections: [
            {
              title: {
                en: 'Sound like a native speaker',
                es: 'Sonar como un hablante nativo',
              }
            },
            {
              title: {
                en: 'Practice with native speakers',
                es: 'Practicar con hablantes nativos',
              }
            },
            {
              title: {
                en: 'Taking feedback and growing',
                es: 'Aceptar críticas y crecer',
              }
            },
          ]
        },
        {
          title: {
            en: 'Pronunciation',
            es: 'Pronunciación',
          },
          sections: [
            {
              title: {
                en: 'Spanish is easy',
                es: 'Español es fácil',
              }
            },
            {
              title: {
                en: 'Methods for improvement',
                es: 'Métodos para mejorar',
              }
            },
            {
              title: {
                en: 'The vowels',
                es: 'Los vocales',
              }
            },
            {
              title: {
                en: 'The consonants',
                es: 'Las consonantes',
              }
            },
          ]
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/text.js